
import Vue from 'vue'
import testimonialsConfig from '~/config/home-testimonials.json'


export default Vue.extend({
  name: 'HomeTestimonials',
  data() {
    return {
      currentTab: 'tokenomics',
      isPlaying: false,
      testimonials: testimonialsConfig,
    }
  },
  computed: {
    activeContent(): any {
      return this.testimonials.find((t: any) => t.id === this.currentTab) || {}
    }
  },
  methods: {
    selectTab(tabId: string) {
      this.currentTab = tabId;
      this.isPlaying = false;
    }
  }
})
